import { IDs } from '../../helpers/IDs';


export function getGewerk(data: any) {

    const unternehmensdaten = data[IDs.ENT_UNTERNEHMENSDATEN];
    if (data && unternehmensdaten && unternehmensdaten.length > 0) {
        if (unternehmensdaten[0].gewerk_tid_orig) {
            return unternehmensdaten[0].gewerk_tid_orig;
        } else {
            return unternehmensdaten[0].gewerk_tid;
        }
    }
    return undefined;
}
export function getGewerkName(data: any) {
    const unternehmensdaten = data[IDs.ENT_UNTERNEHMENSDATEN];
    if (data && unternehmensdaten && unternehmensdaten.length > 0) {
        if (typeof unternehmensdaten[0].gewerk_tid_orig === 'string') {
            return unternehmensdaten[0].gewerk_tid_orig;
        } else if (typeof unternehmensdaten[0].gewerk_tid === 'string') {
            return unternehmensdaten[0].gewerk_tid;
        } else {
            const g = (data[IDs.ENT_BRANCHEN_GEWERKE] || []).find((item: any) => item.tid === unternehmensdaten[0].gewerk_tid);
            if (g) {
                return g.name;
            }
        }
    }
    return undefined;
}
export function getOrtGTZ(data: any) {
    const unternehmensdaten = data[IDs.ENT_UNTERNEHMENSDATEN];
    const orte = data[IDs.ENT_GTZ_ORTE];
    let ort_gtz = null as string;
    if (data && unternehmensdaten && unternehmensdaten.length > 0) {
        ort_gtz = unternehmensdaten[0].ort_gtz;
    }
    const ort_found = ort_gtz && Array.isArray(orte) ? orte.find((o: any) => o.ort === ort_gtz) : null;
    if (ort_found) {
        // console.log('Ort GTZ found: ', ort_found);
        return ort_found.tid;
    }
    return 196;
}
export function getBetrieblicheSituation(data: any) {

    const unternehmensdaten = data[IDs.ENT_UNTERNEHMENSDATEN];
    // console.log('getBS', unternehmensdaten);
    if (data && unternehmensdaten && unternehmensdaten.length > 0) {
        if (unternehmensdaten[0].betriebliche_situation_orig) {
            return unternehmensdaten[0].betriebliche_situation_orig;
        } else {
            if (unternehmensdaten[0].gewerk_tid === 148) { // Harter fix für alte Handwerkskammer-Datensätze
                return null;
            } else {
                return unternehmensdaten[0].betriebliche_situation;
            }
        }
    }
    return undefined;
}
export function getBetrieblicheSituationName(data: any) {

    const unternehmensdaten = data[IDs.ENT_UNTERNEHMENSDATEN];
    if (data && unternehmensdaten && unternehmensdaten.length > 0) {
        const id = unternehmensdaten[0].betriebliche_situation;
        if (id === 'taetigkeit_kunden_bausstelle') {
            return 'Tätigkeit überwiegend bei Kunden / auf Baustelle';
        } else
            if (id === 'taetigkeit_ladengeschaeft') {
                return 'Tätigkeit überwiegend in einem Ladengeschäft';
            } else
                if (id === 'taetigkeit_werkstatt_produktionsstaette') {
                    return 'Tätigkeit überwiegend in einer Werkstatt oder Produktionsstätte';
                }
    }
    return undefined;
}

export function getWZ(data: any) {

    const unternehmensdaten = data[IDs.ENT_UNTERNEHMENSDATEN];
    if (data && unternehmensdaten && unternehmensdaten.length > 0) {
        if (unternehmensdaten[0].wz_tid_orig) {
            return unternehmensdaten[0].wz_tid_orig;
        } else {
            return unternehmensdaten[0].wz_tid;
        }
    }
    return undefined;
}

export function getWZobject(data: any, newUnternehmensdaten?: any[]) {
    const unternehmensdaten = newUnternehmensdaten || data[IDs.ENT_UNTERNEHMENSDATEN];
    const wz_liste = data[IDs.ENT_GEWERKE_WZ] || [];
    if (data && unternehmensdaten && unternehmensdaten.length > 0) {
        let tid: number;
        if (unternehmensdaten[0].wz_tid_orig) {
            tid = unternehmensdaten[0].wz_tid_orig;
        } else {
            tid = unternehmensdaten[0].wz_tid;
        }
        return wz_liste.find((wz: any) => wz.tid === tid);
    }
    return undefined;
}

export function isProduzierendesGewerbe(dataGlobal: any, newUnternehmensdaten?: any[]) {
    const unternehmens = (newUnternehmensdaten || dataGlobal[IDs.ENT_UNTERNEHMENSDATEN] || [])[0] || {};
    const wzobject = getWZobject(dataGlobal, newUnternehmensdaten);
    const isProduzierendesGewerbe = wzobject && wzobject.produzierendes_gewerbe === 1;
    // console.log(wzobject, unternehmens);
    return unternehmens.wz_tid && isProduzierendesGewerbe;
}